
import GalleryFavorite from "../../../assets/duotone/GalleryFavorite.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryFavoriteIcon({ className, dataTestid = "GalleryFavoriteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryFavorite data-testid={dataTestid} className={classes} {...rest} />
  );
}
